var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49775 0.5C9.76834 0.499996 10.0339 0.57319 10.2663 0.711827C10.4987 0.850464 10.6892 1.04938 10.8177 1.2875L11.1823 1.9625C11.3108 2.20062 11.5013 2.39954 11.7337 2.53817C11.9661 2.67681 12.2317 2.75 12.5023 2.75H14C14.3978 2.75 14.7794 2.90804 15.0607 3.18934C15.342 3.47064 15.5 3.85218 15.5 4.25V11C15.5 11.3978 15.342 11.7794 15.0607 12.0607C14.7794 12.342 14.3978 12.5 14 12.5H2C1.60218 12.5 1.22064 12.342 0.93934 12.0607C0.658035 11.7794 0.5 11.3978 0.5 11V4.25C0.5 3.85218 0.658035 3.47064 0.93934 3.18934C1.22064 2.90804 1.60218 2.75 2 2.75H3.49775C3.76807 2.75001 4.03336 2.67698 4.26559 2.53862C4.49781 2.40027 4.68833 2.20173 4.817 1.964L5.18375 1.286C5.31242 1.04827 5.50294 0.849733 5.73516 0.711375C5.96739 0.573018 6.23268 0.499985 6.503 0.5H9.49775Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5C9.24264 9.5 10.25 8.49264 10.25 7.25C10.25 6.00736 9.24264 5 8 5C6.75736 5 5.75 6.00736 5.75 7.25C5.75 8.49264 6.75736 9.5 8 9.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCamera);
export default __webpack_public_path__ + "static/media/event-camera.eb3496aef826d4d9839690336966e358.svg";
export { ForwardRef as ReactComponent };